export enum DeviceTypesEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
}

export enum BrowserTypesEnum {
  EDGE = 'edge',
  IE = 'IE',
  FIREFOX = 'firefox',
  CHROME = 'chrome',
}

export enum OSTypesEnum {
  MACOS = 'mac',
  WINDOWS = 'win',
}

export const I2G_DEVICE_ID = 'i2gDeviceId';

export interface IBrowserInfoHeaders {
  'x-i2g-device': string;
  'x-i2g-device-id': string;
  'x-i2g-platform': string;
  'x-i2g-client': string;
}
